import { AfterContentInit, Component, TemplateRef, ViewChild } from '@angular/core';
import { MuiHeroRightAppBarService } from './mui-hero-right-app-bar.service';

@Component({
  selector: 'mui-hero-right-app-bar',
  templateUrl: './mui-hero-right-app-bar.component.html',
  styles: [
    `
      :host {
        display: none;
      }
    `
  ]
})
export class MuiRightAppBarContent implements AfterContentInit {
  @ViewChild('rightAppBar') rightAppBar?: TemplateRef<any>;

  constructor(private rightAppBarService: MuiHeroRightAppBarService) {}

  ngAfterContentInit(): void {
    this.rightAppBarService.rightAppBar = this;
  }
}
